import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page, LoadingPage, StarRating } from '../shared';

import ReviewTalentEvaluation from './reviewTalentEvaluation';
import CompleteTalentEvaluation from './completeTalentEvaluation';
import EditTalentEvaluation from './editTalentEvaluation';

import Select from 'react-select';

import ReactTooltip from 'react-tooltip';

import {
  getFourboxTalentCategories,
} from '../../util';
import {
  getReportingAndEvaluationPeriodsForThisYear,
  getCurrentQuarterString,
  getCurrentEvaluationDate,
  getCurrentQuarterReviewType,
  isInEvaluationPeriodForCurrentQuarter,
  getLastQuarterString
} from '../../util/quarters';
import { getIcon } from '../../util/icons';

import { fetchCurrentSprintForEmployee } from '../../actions/sprint'
import { fetchTalentEvaluationsForEmployee, saveTalentEvaluation, updateTalentEvaluation } from '../../actions/talentEvaluations';

class TalentsPage extends Component {

  state = {
    employeeId: null,
    reviewingQuarter: null,
    completingEvaluation: false,
    editingEvaluation: false,
  }

  isOwnTalentEvaluations(){
    return !this.props.isViewingUser;
  }

  reviewingQuarterTalentEvaluationData(){

    const { reviewingQuarter } = this.state;

    let reviewingQuarterTalentEvaluationData;

    if(!this.talentEvaluationHistory()[reviewingQuarter]){
      return null;
    }
    else if(reviewingQuarter === 'Initial'){
      //initial review always only "self" data
      if(this.isOwnTalentEvaluations()){
        reviewingQuarterTalentEvaluationData = this.talentEvaluationHistory()[reviewingQuarter].selfReview;
      }
      else{
        reviewingQuarterTalentEvaluationData = this.talentEvaluationHistory()[reviewingQuarter].managerReview;
      }
    }
    else if(this.isOwnTalentEvaluations()){
      reviewingQuarterTalentEvaluationData = this.talentEvaluationHistory()[reviewingQuarter].selfReview || this.talentEvaluationHistory()[reviewingQuarter].jointReview;
    }
    else{
      reviewingQuarterTalentEvaluationData = this.talentEvaluationHistory()[reviewingQuarter].managerReview || this.talentEvaluationHistory()[reviewingQuarter].jointReview;
    }

    return reviewingQuarterTalentEvaluationData;
  }

  renderPageTitle(){

    const { reviewingQuarter, completingEvaluation } = this.state;

    const userName = this.props.isViewingUser ? (this.props.viewingUser || {}).firstName + '\'s' : 'Your';

    if(completingEvaluation){
      return (
        <div className="page-title">
          {this.isOwnTalentEvaluations() &&
            <h1>Evaluate {userName} talents</h1>
          }
          {!this.isOwnTalentEvaluations() &&
            <h1>Evaluate {userName} talents</h1>
          }
          <h3><button onClick={() => { this.setState({ completingEvaluation: false }) }} className="button grey-outline button-micro">Cancel and discard responses</button></h3>
        </div>
      );
    }
    else if(!this.userHasCompletedTalentEvaluationInitially() && this.isOwnTalentEvaluations()){
      return(
        <div className="page-title no-subheader">
          <h1>Complete Initial Self Evaluation...</h1>
        </div>
      )
    }
    else if(!this.managerHasCompletedTalentEvaluationInitially() && !this.isOwnTalentEvaluations()){
      return(
        <div className="page-title no-subheader">
          <h1>Complete Initial Evaluation...</h1>
        </div>
      )
    }
    else if(reviewingQuarter){

      if(!this.reviewingQuarterTalentEvaluationData()){
        //no data to review
        return(
          <div className="page-title no-subheader">
            <h1>{reviewingQuarter} {this.getCurrentQuarterRatedByString()} Evaluation</h1>
          </div>
        )
      }
      else{
        return(
          <div className="page-title">
            <h1>{reviewingQuarter} Evaluation</h1>
            <h3>Completed on {moment(this.reviewingQuarterTalentEvaluationData().ratedOn).format('M/D/YYYY')}</h3>
          </div>
        )
      }
    }
    else{
      return (
        <div className="page-title">
          <h1>{userName} Talent Card</h1>
          <h3>Current review period: {this.currentEvaluationPeriod()}</h3>
        </div>
      );
    }

    //<h5>Current review state: {getCurrentQuarterReviewType()}</h5>
  }

  organizationTalents(){
    const { sprintGoals } = (this.props.organization || {});

    return _.filter(sprintGoals || [], goal => {
      return !goal.inactive && (goal.category === 'behavior' || goal.category === 'skill');
    });
  }

  currentTalents(){

    if(!this.userHasCompletedTalentEvaluationInitially()){
      return null;
    }

    const sprintData = this.props.sprintData;

    const sprintBehaviorsAndSkills = _.filter(sprintData.goals, goal => {
      return goal.category === 'behavior' || goal.category === 'skill';
    });

    let currentTalents = [];

    //console.log('searching: ', this.organizationTalents());

    _.each(sprintBehaviorsAndSkills, goal => {
      const matchingTalent = _.find(this.organizationTalents(), talent => {
        return talent.id === goal.id;
      });

      if(!matchingTalent){
        console.log('no matching talent found for goal: ', goal);
      }
      else{
        currentTalents.push(matchingTalent);
      }
    });

    //console.log('currentTalents: ', currentTalents);
    return currentTalents;
  }

  isFocusingTalentsForCurrentEvaluation(){
    const isFocusingTalentsForCurrentEvaluation = this.userHasCompletedTalentEvaluationInitially() && this.managerHasCompletedTalentEvaluationInitially() && getCurrentQuarterReviewType() === 'quarter';
    console.log('isFocusingTalentsForCurrentEvaluation: ', isFocusingTalentsForCurrentEvaluation);
    return isFocusingTalentsForCurrentEvaluation;
  }

  userHasCompletedTalentEvaluationInitially(){
    const talentEvaluations = this.props.talentEvaluationsData;

    // console.log('checking userHasCompletedTalentEvaluationInitially ');
    // console.log(talentEvaluations);

    const initialTalentEvaluation = _.find(talentEvaluations, talentEvaluation => {
      return talentEvaluation.ratedBy === 'self' && talentEvaluation.period === 'Initial';
    });

    return initialTalentEvaluation ? true : false;
  }
  managerHasCompletedTalentEvaluationInitially(){
    const talentEvaluations = this.props.talentEvaluationsData;

    // console.log('checking managerHasCompletedTalentEvaluationInitially ');
    // console.log(talentEvaluations);

    const initialTalentEvaluation = _.find(talentEvaluations, talentEvaluation => {
      return talentEvaluation.ratedBy === 'manager' && talentEvaluation.period === 'Initial';
    });

    return initialTalentEvaluation ? true : false;
  }

  currentEvaluationPeriod(){
    if(isInEvaluationPeriodForCurrentQuarter()){
      return getCurrentQuarterString();
    }
    else{
      return getLastQuarterString();
    }
  }

  talentEvaluationHistoryForCurrentQuarter(){

    const currentEvalutionPeriod = this.currentEvaluationPeriod();

    const talentEvaluationHistoryForCurrentQuarter = _.find(this.talentEvaluationHistory(), talentEvaluationHistory => {
      return talentEvaluationHistory.period === currentEvalutionPeriod;
    });

    return talentEvaluationHistoryForCurrentQuarter;
  }

  currentUserNeedsToCompleteSurveyThisQuarter(){

    if(!isInEvaluationPeriodForCurrentQuarter()){
      return false;
    }

    const talentEvaluationHistoryForCurrentQuarter = this.talentEvaluationHistoryForCurrentQuarter();

    console.log('talentEvaluationHistoryForCurrentQuarter: ', talentEvaluationHistoryForCurrentQuarter);
    console.log('this.isOwnTalentEvaluations()', this.isOwnTalentEvaluations());

    if(getCurrentQuarterReviewType() === 'quarter'){
      if(!this.isOwnTalentEvaluations()){
        return (talentEvaluationHistoryForCurrentQuarter && talentEvaluationHistoryForCurrentQuarter.jointReview) ? false : true;
      }
      else{
        //only managers complete these
        return false;
      }
    }
    else if(getCurrentQuarterReviewType() === 'annual'){
      if(this.isOwnTalentEvaluations()){
        return (talentEvaluationHistoryForCurrentQuarter && talentEvaluationHistoryForCurrentQuarter.selfReview) ? false : true;
      }
      else{
        return (talentEvaluationHistoryForCurrentQuarter && talentEvaluationHistoryForCurrentQuarter.managerReview) ? false : true;
      }
    }
  }

  renderSurveyPrompt(){

    const { completingEvaluation, reviewingQuarter } = this.state;

    //if completing evaluation now or reviewing past quarter
    if(reviewingQuarter !== this.currentEvaluationPeriod()){
      return null;
    }

    const userName = this.props.isViewingUser ? (this.props.viewingUser || {}).firstName : 'your';

    const userNamePosessive = userName + '\'s';

    if(completingEvaluation){
      return <p>Rate {userNamePosessive} sales effectiveness for the following behaviors and skills...</p>
    }

    if(!this.userHasCompletedTalentEvaluationInitially() && this.isOwnTalentEvaluations()){
      return(
        <div>
          <p>You have not completed your initial talent evaluation. Complete now?</p>
          <button onClick={() => { this.setState({completingEvaluation: true}) }} className="button primary">Complete Initial Evaluation</button>
        </div>
      );
    }
    if(!this.managerHasCompletedTalentEvaluationInitially() && !this.isOwnTalentEvaluations()){
      return(
        <div>
          <p>You have not completed your initial talent evaluation for {userName}. Complete now?</p>
          <button onClick={() => { this.setState({completingEvaluation: true}) }} className="button primary">Complete Initial Evaluation</button>
        </div>
      );
    }

    if(this.currentUserNeedsToCompleteSurveyThisQuarter()){

      return(
        <div>
          <p>You have not completed {userNamePosessive} talent evaluation for this {getCurrentQuarterReviewType() === 'quarter' ? 'quarter' : 'year'}. Complete now?</p>
          <button onClick={() => { this.setState({completingEvaluation: true}) }} className="button primary">Complete {getCurrentQuarterReviewType() === 'quarter' ? this.currentEvaluationPeriod() : 'Annual'} {this.getCurrentQuarterRatedByString()} Evaluation</button>
        </div>
      );
    }
    else if(!this.talentEvaluationHistoryForCurrentQuarter()){
      return (
        <div>
          {isInEvaluationPeriodForCurrentQuarter() &&
            <p>Awaiting joint review.</p>
          }
          {!isInEvaluationPeriodForCurrentQuarter() &&
            <p>Talent evaluation not completed for this period.</p>
          }
        </div>
      )
    }

    else{
      //no prompt, just show review
      return null;
    }
  }

  updateCurrentEvaluationRatings(ratings){
    const ratingsTotal = _.reduce(ratings, (memo, rating) => {
      return memo + rating;
    }, 0);

    const ratingsOutOf = _.size(ratings) * 10;

    const ratingsAvgRating = (ratingsTotal / ratingsOutOf) * 10.0;

    const ratedBy = this.getRatedByForSubmission();

    this.props.updateTalentEvaluation(this.state.employeeId, {
      //TODO find out if I should be saving talents, or if I can just ignore them
      _id: this.reviewingQuarterTalentEvaluationData()._id,
      talents: this.organizationTalents(),
      ratings,
      ratedBy,
      ratedOn: moment().valueOf(),
      raterId: this.props.user.uid,
      ratingsTotal,
      ratingsOutOf,
      ratingsAvgRating,
      userId: this.state.employeeId,
      period: this.getCurrentRatingPeriodForSubmission(),
      periodDate: getCurrentEvaluationDate().valueOf(),
    }, newTalentEvaluation => {

      this.setState({
        editingEvaluation: false,
      });

      //refetch all data
      this.props.fetchTalentEvaluationsForEmployee(this.state.employeeId, talentEvaluations => {
        console.log('received talent evaluations: ', talentEvaluations);
      });
    });
  }

  renderEditTalentEvaluation(){
    const { editingEvaluation, reviewingQuarter } = this.state;

    // console.log('reviewingQuarter: ', reviewingQuarter);
    // console.log('editingQuarterTalentEvaluationData: ', this.reviewingQuarterTalentEvaluationData());

    if(!editingEvaluation){
      return null;
    }

    const reviewingTalentEvaluations = this.talentEvaluationHistory()[reviewingQuarter];

    // console.log('reviewingTalentEvaluations: ', reviewingTalentEvaluations);

    return <EditTalentEvaluation
      updatingRatings={this.props.talentEvaluations.saving}
      talents={this.organizationTalents()}
      focusedTalents={this.currentTalents()}
      isOwnCard={this.isOwnTalentEvaluations()}
      updateRatings={this.updateCurrentEvaluationRatings.bind(this)}
      cancel={() => { this.setState({ editingEvaluation: false }) }}
      managerReview={reviewingTalentEvaluations.managerReview}
      jointReview={reviewingTalentEvaluations.jointReview}
      />;
  }

  renderReviewTalentEvaluation(){

    const { reviewingQuarter, editingEvaluation } = this.state;

    // console.log('reviewingQuarter: ', reviewingQuarter);
    // console.log('reviewingQuarterTalentEvaluationData: ', this.reviewingQuarterTalentEvaluationData());

    if(!reviewingQuarter || !this.reviewingQuarterTalentEvaluationData() || editingEvaluation){
      return null;
    }

    // console.log('reviewingQuarter: ', reviewingQuarter);

    const reviewingTalentEvaluations = this.talentEvaluationHistory()[reviewingQuarter];

    // console.log('reviewingTalentEvaluations: ', reviewingTalentEvaluations);

    return <ReviewTalentEvaluation
      allTalents={this.organizationTalents()}
      focusedTalents={this.currentTalents()}
      period={reviewingQuarter}
      selfReview={reviewingTalentEvaluations.selfReview}
      managerReview={reviewingTalentEvaluations.managerReview}
      jointReview={reviewingTalentEvaluations.jointReview}
      isOwnCard={this.isOwnTalentEvaluations()}
      />;
  }

  getRatedByForSubmission(){
    if(!this.userHasCompletedTalentEvaluationInitially() || !this.managerHasCompletedTalentEvaluationInitially()){
      return this.isOwnTalentEvaluations() ? 'self' : 'manager';
    }
    else{
      if(getCurrentQuarterReviewType() === 'annual'){
        return this.isOwnTalentEvaluations() ? 'self' : 'manager';
      }
      else{
        //quarterly, therefore joint
        return 'joint';
      }
    }
  }
  getCurrentQuarterRatedByString(){
    const ratedByForSubmission = this.getRatedByForSubmission();

    switch(ratedByForSubmission){
      default:
      case 'self':
        return 'Self';
      case 'manager':
        return 'Manager';
      case 'joint':
        return 'Joint';
    }
  }

  getCurrentRatingPeriodForSubmission(){
    console.log('getCurrentRatingPeriodForSubmission: ');
    console.log('managerHasCompletedTalentEvaluationInitially: ', this.managerHasCompletedTalentEvaluationInitially());
    if(!this.userHasCompletedTalentEvaluationInitially() && this.isOwnTalentEvaluations()){
      return 'Initial';
    }
    else if(!this.managerHasCompletedTalentEvaluationInitially() && !this.isOwnTalentEvaluations()){
      console.log('manager not completed initial!!!');
      return 'Initial';
    }
    else{
      console.log('goto current');
      return this.currentEvaluationPeriod();
    }
  }

  submitRatings(ratings){

    const ratingsTotal = _.reduce(ratings, (memo, rating) => {
      return memo + rating;
    }, 0);

    const ratingsOutOf = _.size(ratings) * 10;

    const ratingsAvgRating = (ratingsTotal / ratingsOutOf) * 10.0;

    const ratedBy = this.getRatedByForSubmission();

    const ratingPeriod = this.getCurrentRatingPeriodForSubmission();

    this.props.saveTalentEvaluation(this.state.employeeId, {
      //TODO find out if I should be saving talents, or if I can just ignore them
      talents: this.organizationTalents(),
      ratings,
      ratedBy,
      ratedOn: moment().valueOf(),
      raterId: this.props.user.uid,
      ratingsTotal,
      ratingsOutOf,
      ratingsAvgRating,
      userId: this.state.employeeId,
      period: this.getCurrentRatingPeriodForSubmission(),
      periodDate: getCurrentEvaluationDate().valueOf()
    }, () => {
      this.setState({
        completingEvaluation: false,
        reviewingQuarter: ratingPeriod,
      });
    });
  }

  onlyInitialEvaluationOrEvaluationsCompleted(){
    if(!this.userHasCompletedTalentEvaluationInitially() && !this.managerHasCompletedTalentEvaluationInitially()){
      return false;
    }
    return !_.find(this.talentEvaluationHistory(), talentEvaluation => {
      return talentEvaluation.period !== 'Initial';
    }) ? true : false;
  }

  getPriorReviews(){
    let priorReviews = null;

    if(this.onlyInitialEvaluationOrEvaluationsCompleted() && this.isOwnTalentEvaluations()){
      priorReviews = _.find(this.talentEvaluationHistory(), talentEvaluation => {
        return talentEvaluation.selfReview && talentEvaluation.period === 'Initial';
      });
    }
    else if(this.onlyInitialEvaluationOrEvaluationsCompleted() && !this.isOwnTalentEvaluations()){
      // console.log('checking manager prior reviews...should look to initial');
      // console.log('complete history: ', this.talentEvaluationHistory());
      priorReviews = _.find(this.talentEvaluationHistory(), talentEvaluation => {
        // console.log('checking: ', talentEvaluation);
        return talentEvaluation.managerReview && talentEvaluation.period === 'Initial';
      });
      // console.log('found priorReviews: ', priorReviews);
    }
    else if(this.talentEvaluationHistory()[getLastQuarterString()]){
      priorReviews = this.talentEvaluationHistory()[getLastQuarterString()];
    }
    //Can't use this because we can't assume both managers and self complete every review
    //so "last review" might leave some data blank. For now only show initial or LAST quarter review data

    else{
      //if no reviews LAST period, then just use the most recent reviews
      priorReviews = _.sortBy(this.talentEvaluationHistory(), talentEvaluation => {
        return talentEvaluation.ratedOn;
      })[0] || null;

      //don't use initial if using this method
      if(priorReviews && priorReviews.period === 'Initial'){
        priorReviews = null;
      }

      // console.log('priorReviews: ELSE: ', priorReviews);
    }

    return priorReviews;
  }

  renderCompleteTalentEvaluation(){
    if(this.state.completingEvaluation){
      // console.log('getPriorQuarterString: ', getPriorQuarterString());
      // console.log('talentEvaluationHistory: ', this.talentEvaluationHistory());

      //console.log('should be rendering talents: ', this.organizationTalents());

      return <CompleteTalentEvaluation
        submittingRatings={this.props.talentEvaluations.saving}
        priorReviews={this.getPriorReviews()}
        talents={this.organizationTalents()}
        focusedTalents={this.currentTalents()}
        onlyShowFocused={this.isFocusingTalentsForCurrentEvaluation()}
        isOwnCard={this.isOwnTalentEvaluations()}
        submitRatings={this.submitRatings.bind(this)}
        cancel={() => { this.setState({ completingEvaluation: false }) }}
        />
    }
    else{
      return null;
    }
  }

  talentEvaluationHistory(){
    const talentEvaluations = this.props.talentEvaluationsData || [];

    const groupedTalentEvaluations = _.groupBy(talentEvaluations, talentEvaluation => {
      return talentEvaluation.period;
    });

    let talentEvaluationHistory = {};

    _.each(groupedTalentEvaluations, (talentEvaluationsForPeriod, index) => {
      talentEvaluationHistory[index] = {
        period: index,
        selfReview: _.find(talentEvaluationsForPeriod, talentEvaluation => {
          return talentEvaluation.ratedBy === 'self';
        }) || null,
        managerReview: _.find(talentEvaluationsForPeriod, talentEvaluation => {
          return talentEvaluation.ratedBy === 'manager';
        }) || null,
        jointReview: _.find(talentEvaluationsForPeriod, talentEvaluation => {
          return talentEvaluation.ratedBy === 'joint';
        }) || null,
      }
    });

    return talentEvaluationHistory;
  }

  reviewQuarter(quarterName){
    this.setState({
      reviewingQuarter: quarterName
    });
  }

  renderTalentHistorySelect(){

    if(!this.userHasCompletedTalentEvaluationInitially() && this.isOwnTalentEvaluations()){
      return null;
    }
    else if(!this.managerHasCompletedTalentEvaluationInitially() && !this.isOwnTalentEvaluations()){
      return null;
    }

    const { reviewingQuarter } = this.state;

    let talentEvaluationHistoryOptions = _.map(this.talentEvaluationHistory(), (talentEvaluationHistory, quarter) => {
      return {
        label: quarter,
        value: quarter
      }
    });

    talentEvaluationHistoryOptions = _.sortBy(talentEvaluationHistoryOptions, option => {

      //should be last
      if(option.value === 'Initial'){
        return '';
      }

      return option.value;
    }).reverse();

    //if no value for current quarter, add it now
    if(!this.talentEvaluationHistoryForCurrentQuarter()){
      talentEvaluationHistoryOptions.unshift({
        label: this.currentEvaluationPeriod(),
        value: this.currentEvaluationPeriod(),
      });
    }

    const talentEvaluationHistorySelectValue = reviewingQuarter ? {
      label: reviewingQuarter,
      value: reviewingQuarter,
    } : null;

    return (
      <Select
        placeholder="Past evaluations"
        classNamePrefix={'react-select'}
        className='react-select-container talent-evaluation-history-select'
        value={talentEvaluationHistorySelectValue}
        options={talentEvaluationHistoryOptions}
        onChange={(option) => { this.reviewQuarter(option.value) }}
        isSearchable={false}
      />
    );

    /*
    getOptionLabel={option => { return option; }}
    getOptionValue={option => { console.log('getting option value as: ', option); return option; }}
    isOptionSelected={(option, allOptions) => { return option === reviewingQuarter; }}
    */

  }

  editPastEvaluation(){
    this.setState({
      editingEvaluation: true
    });
  }

  renderEditAction(){
    if(!this.talentEvaluationHistoryForCurrentQuarter() || this.state.reviewingQuarter !== this.currentEvaluationPeriod() || this.isOwnTalentEvaluations() || !isInEvaluationPeriodForCurrentQuarter()){
      return null;
    }
    else{
      return(
        <div className="action-group">
          <div data-tip="Edit Evaluation" data-tip="Edit ratings" onClick={this.editPastEvaluation.bind(this)} className="action">{getIcon('edit', 'light')}</div>
          <ReactTooltip effect="solid" place="top"/>
        </div>
      )
    }
  }

  render(){

    const { organization } = this.props;

    //don't attempt to render until organization loaded
    //ideally I'd control this from the <Page> compoenent, but "loading" doesn't prevent the children from rendering
    if(!organization){
      return <LoadingPage pageClass="sprint" />
    }

    const { reviewingQuarter, editingEvaluation, completingEvaluation } = this.state;

    const { isOwnTalentEvaluations } = this.isOwnTalentEvaluations();

    const talentEvaluations = this.props.talentEvaluationsData;

    const loading = !organization || this.props.loadingTalentEvaluationsData;

    return (
      <Page pageClass="talents" loading={loading}>
        {this.renderPageTitle()}
        {talentEvaluations && talentEvaluations.length > 0 && !completingEvaluation && !editingEvaluation &&
          <div className="page-actions">
            {this.renderTalentHistorySelect()}
            {this.renderEditAction()}
          </div>
        }
        <div className="page-content">
          <div className="page-section">
            {this.renderSurveyPrompt()}
            {this.renderReviewTalentEvaluation()}
            {this.renderCompleteTalentEvaluation()}
            {this.renderEditTalentEvaluation()}
          </div>
        </div>
      </Page>
    )
  }

  componentWillReceiveProps(nextProps){
    //once we have organization data, we can calculate current quarter for review
    if(nextProps.organization && !this.state.reviewingQuarter){
      this.setState({
        reviewingQuarter: this.currentEvaluationPeriod()
      });
    }
  }

  componentWillMount(){

    const { match: { params } } = this.props;

    let employeeId = params.employeeId;

    //if no employeeId...user accessing sprint
    //TODO figure out a better way of managing this
    if(employeeId){
      this.setState({
        employeeId,
        isOwnTalentEvaluations: false,
      })
    }
    else{
      employeeId = this.props.user.uid;

      this.setState({
        employeeId,
        isOwnTalentEvaluations: true,
      });
    }

    //need this data for knowing what "current talents" are.
    this.props.fetchCurrentSprintForEmployee(employeeId);

    this.props.fetchTalentEvaluationsForEmployee(employeeId, talentEvaluations => {
      console.log('received talent evaluations: ', talentEvaluations);
    });
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    viewingUser: state.viewingUser.data,
    editingUser: state.editingUser,
    organization: state.organization.data,
    sprintData: state.sprint.data,
    talentEvaluations: state.talentEvaluations,
    talentEvaluationsData: state.talentEvaluations.data,
    loadingTalentEvaluationsData: state.talentEvaluations.loading,
  }
}

export default connect(mapStateToProps, { fetchCurrentSprintForEmployee, fetchTalentEvaluationsForEmployee, saveTalentEvaluation, updateTalentEvaluation })(TalentsPage);



// WEBPACK FOOTER //
// ./src/components/talents/index.js